import { useTranslation } from "react-i18next";
import Button from "../../components/buttons/button";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useState } from "react";
import Popup from "../../components/popups/popup";
import AddMember from "./addMember";
import SearchMembers from "./searchMembers";
import MembersTable from "./membersTable";
import ViewMember from "./viewMember";
import EditMember from "./editMember";
import AcceptRequest from "./acceptRequest";
import StarIcon from "../../icons/starIcon";
import MessagePopup from "../../components/popups/messagePopup";
import DeleteMember from "./deleteMember";
import Paginate from "../../components/pagination/paginate";
import SearchSelect from "../../components/select/searchSelect";
import { useOptions } from "../../components/hooks/useOptionsHook";

const Members = () => {
  const { t } = useTranslation();
  const [openAdd, setOpenAdd] = useState(false);
  const [selected, setSelected] = useState(null);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openRequest, setOpenRequest] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  return (
    <main>
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <h1 className="mb-3 text-lg font-bold capitalize md:text-2xl text-primary">
          {t("membersManagement")}
        </h1>
        <Button
          onClick={() => setOpenAdd(true)}
          className={"bg-primary text-black"}
          type={"button"}
        >
          <AiOutlinePlusCircle />
          {t("addNewMember")}
        </Button>
      </div>
      <article className="mainLinear grid p-4 rounded-[20px] mt-8">
        <SearchMembers t={t} />
        <MembersTable
          t={t}
          setSelected={setSelected}
          setOpenView={setOpenView}
          setOpenEdit={setOpenEdit}
          setOpenRequest={setOpenRequest}
          setOpenDelete={setOpenDelete}
        />
      </article>
      <div className="flex items-center gap-2">
        <Paginate data={data} />
        <div>
          <SearchSelect
            options={paginationOptions}
            onChange={(e) => {
              alert("now paginating " + e.value);
            }}
            name={"paginate"}
            placeholder={t("show 10")}
          />
        </div>
      </div>
      <Popup open={openAdd} setOpen={setOpenAdd} header={t("addNewMember")}>
        <AddMember t={t} setOpen={setOpenAdd} />
      </Popup>
      <Popup open={openView} setOpen={setOpenView} header={t("memberDetails")}>
        <ViewMember t={t} />
      </Popup>
      <Popup open={openEdit} setOpen={setOpenEdit} header={t("editMember")}>
        <EditMember t={t} setOpen={setOpenAdd} selected={selected} />
      </Popup>
      <Popup
        open={openRequest}
        setOpen={setOpenRequest}
        header={
          <span className="grid rounded-full  size-11 place-content-center bg-[#383943]">
            <StarIcon />
          </span>
        }
      >
        <AcceptRequest t={t} selected={selected} setOpen={setOpenRequest} />
      </Popup>
      <MessagePopup open={openDelete} setOpen={setOpenDelete}>
        <DeleteMember t={t} selected={selected} setOpen={setOpenDelete} />
      </MessagePopup>
    </main>
  );
};

export default Members;
